import { createFileRoute } from "@tanstack/react-router";

import { HighlightsPage, highlightsSearchSchema } from "@/features/highlights";

// «Хайлайты»: экран из фичи `highlights`. Фильтр и матч, к которому пришли из разбора или
// списка матчей, — в search params; фильтр меняется без новой записи в истории браузера.
const Highlights = () => {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <HighlightsPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true, resetScroll: false })}
    />
  );
};

export const Route = createFileRoute("/highlights")({
  validateSearch: highlightsSearchSchema,
  component: Highlights,
});
